<template>
    <el-dialog
        title="编辑收货地址"
        :visible.sync="visible"
        @close="handleCancel"
        width="600px"
    >
        <el-form :model="form" :rules="rules" label-width="80px">
            <el-form-item label="所在地区" prop="addr">
                <el-select-address :widths="['120px', '100px', undefined, -1]" v-model="address" />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
                <el-input v-model.number="form.phone" maxlength="11"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">保 存</el-button>
        </span>
   </el-dialog>
</template>

<script>

export default {
    data(){
        var checkPhone = (rule, value, callback) => {
            if (value.toString().length != 11) {
                return callback(new Error('请输入正确的手机号格式!'));
            }

        };
        return {
            rules:{
                addr:[
                    { required: true, message: '请选择地区', trigger: 'blur' },
                ],
                address:[
                    { required: true, message: '请输入详细地址', trigger: 'blur' },
                ],
                name:[
                    { required: true, message: '请输入收件人姓名', trigger: 'blur' },
                ],
                phone:[
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { validator:checkPhone, trigger: 'blur' }
                ],
            },
            visible:false,
            address:[],
            form:{},
        }
    },
    methods:{
        method_open(){
            this.visible = true
        },
        handleCancel(){
            this.visible = false
        },
        handleSave(){

        }
    }
}
</script>
